import React from 'react'
import "./Promo.css";
import { Col, Container, Row } from 'react-bootstrap'
import PromoImg1 from '../../Images/promo1.jpg'
import PromoImg2 from '../../Images/promo2.jpg'
import PromoImg3 from '../../Images/promo3.jpg'
import PromoImg4 from '../../Images/promo4.jpg'
import Color1 from '../../Images/1.png'
import Color2 from '../../Images/2.png'
import Color3 from '../../Images/3.png'
import Color4 from '../../Images/4.png'
import Color5 from '../../Images/5.png'
import Color6 from '../../Images/6.png'
import Color7 from '../../Images/7.png'
import Color8 from '../../Images/8.png'
import Color9 from '../../Images/9.png'
import Color10 from '../../Images/10.png'
import Star from '../../Images/star.png'
import NfcCard1 from '../../Images/nfc_card1.png'
import NfcCard2 from '../../Images/nfc_card2.png'
import NfcCard3 from '../../Images/nfc_card3.png'
import NfcCard4 from '../../Images/nfc_card4.png'
// import NfcCard5 from '../../Images/nfc_card5.png'

const PromotionBanners = () => {
  return (
    <>
        <div className='rootpromo'>
            <Container fluid className='promomain'>
            <Row style={{margin:"0"}}>
                <Col md={6} lg={3}>
                    <img src={NfcCard1} style={{width:"100%", padding:"30px"}}/>
                </Col>
                {/* <Col md={3}>
                    <img src={NfcCard2} style={{width:"100%", padding:"30px"}}/>
                </Col> */}
                <Col md={6} lg={3}>
                    <img src={NfcCard2} style={{width:"100%", padding:"30px"}}/>
                </Col>
                <Col md={6} lg={3}>
                    <img src={NfcCard3} style={{width:"100%", padding:"30px"}}/>
                </Col>
                <Col md={6} lg={3}>
                    <img src={NfcCard4} style={{width:"100%", padding:"30px"}}/>
                </Col>
                {/* <Col md={3}>
                    <img src={PromoImg2} className='promoimgset'/>
                    <h2>Bamboo NFC Business Cards</h2>
                    <h3><span>Dhs. 456.00</span> Dhs. 120</h3>
                    <ul>
                        <li><img src={Star}/></li>
                        <li><img src={Star}/></li>
                        <li><img src={Star}/></li>
                        <li><img src={Star}/></li>
                        <li><img src={Star}/></li>
                        <li>(915)</li>
                    </ul>
                    <ul className='circlecolor'>
                        <li className='colorsmain'><img src={Color1}/></li>
                        <li className='colorsmain'><img src={Color2}/></li>
                        <li className='colorsmain'><img src={Color3}/></li>
                        <li className='colorsmain'><img src={Color4}/></li>
                        <li className='colorsmain'><img src={Color5}/></li>
                    </ul>
                </Col>

                <Col md={3}>
                    <img src={PromoImg3} className='promoimgset'/>
                    <h2>Original NFC Business Cards</h2>
                    <h3><span>Dhs. 350.00</span> Dhs  99</h3>
                    <ul>
                        <li><img src={Star}/></li>
                        <li><img src={Star}/></li>
                        <li><img src={Star}/></li>
                        <li><img src={Star}/></li>
                        <li><img src={Star}/></li>
                        <li>(915)</li>
                    </ul>
                    <ul className='circlecolor'>
                        <li className='colorsmain'><img src={Color1}/></li>
                        <li className='colorsmain'><img src={Color2}/></li>
                        <li className='colorsmain'><img src={Color3}/></li>
                        <li className='colorsmain'><img src={Color4}/></li>
                        <li className='colorsmain'><img src={Color5}/></li>
                        <li className='colorsmain'><img src={Color6}/></li>
                        <li className='colorsmain'><img src={Color7}/></li>
                    </ul>
                </Col>

                <Col md={3}>
                    <div className='bottomdata'>
                        <img src={PromoImg4} className='promoimgset'/>
                        <h2>24k Gold NFC Business Cards</h2>
                        <h3><span>Dhs. 1,766.00</span> Dhs 599</h3>
                        <ul>
                            <li><img src={Star}/></li>
                            <li><img src={Star}/></li>
                            <li><img src={Star}/></li>
                            <li><img src={Star}/></li>
                            <li><img src={Star}/></li>
                            <li>(915)</li>
                        </ul>
                    </div>
                </Col> */}
                
            </Row>
            </Container>
        </div>
    
    </>
  )
}

export default PromotionBanners